// extracted by mini-css-extract-plugin
export var aboveInput = "_ig-0";
export var actionButton = "_ig-5";
export var actionButtonContainer = "_ig-1";
export var actionIcon = "_ig-6";
export var aiInfoContainer = "_ig-2";
export var attachmentWrapper = "_ig-7";
export var bold = "_ig-3";
export var checkIcon = "_ig-8";
export var clickingRecipientBar = "_ig-11";
export var commentThreadSwitch = "_ig-a";
export var draftImage = "_ig-b";
export var draftImageContainer = "_ig-c";
export var draftImages = "_ig-e";
export var editButton = "_ig-g";
export var editor = "_ig-f";
export var editorContainer = "_ig-y";
export var editorErrorTooltipWrapper = "_ig-9";
export var headerDivider = "_ig-h";
export var icon = "_ig-i";
export var info = "_ig-j";
export var internal = "_ig-n";
export var internalDivider = "_ig-k";
export var internalMessage = "_ig-l";
export var messageInputCard = "_ig-m";
export var messageInputForm = "_ig-o";
export var messageInputFormInternal = "_ig-p";
export var options = "_ig-q";
export var publicMessageCustomer = "_ig-s";
export var publicMessageMerchant = "_ig-r";
export var removeImageButton = "_ig-d";
export var replyButtons = "_ig-t";
export var showSignatureButton = "_ig-u";
export var spinner = "_ig-v";
export var verticalButtonDivider = "_ig-4";
export var visibilitySelector = "_ig-w";
export var warning = "_ig-x";
export var wrappingText = "_ig-z";
export var writingInternalNoteTopBorder = "_ig-10";